export class ItemInfoModel {

  
	partNumber:string = "";
	partClass:string = "";
	swbtype:string = "";
	partRevision:string = "";
	partPpa:string = "";
	ePromotedPlatforms:string = "";
	operatingSystems:string = "";
	languages:string = "";
	royaltyFlag:string = "";
	regionsAffected:string = "";
	lobsAffected:string = "";
}
